import { createSelector } from '@reduxjs/toolkit';
import { selectBedrooms } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'от 1', value: 1 },
  { label: 'от 2', value: 2 },
  { label: 'от 3', value: 3 },
  { label: 'от 4', value: 4 },
  { label: 'от 5', value: 5 },
];

export const selectBedroomsFilter = createSelector(selectBedrooms, ({ gte = null }) => ({
  label: 'Спален в доме',
  value: [gte],
  options: OPTIONS,
}));
